import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import './Submenu.css';

const SubMenu = ({ history, location }) => {
  const subMenus = {
    '/publications': [
      { label: 'Mother Wound', path: '/publications/mother-wound' },
      { label: 'Writing', path: '/publications/writing' },
      { label: 'Editorial', path: '/publications/editorial' },
    ],
    '/movies': [
      { label: 'Twenty Eight Days', path: '/movies/twenty-eight-days' },
      { label: 'Other Movies', path: '/movies/other-movies' },
    ],
    // '/pedagogy': [
    //   { label: 'Syllabi', path: '/pedagogy/syllabi' },
    //   { label: 'Workshops', path: '/pedagogy/workshops' },
    // ],
  };

  const currentMenu = Object.keys(subMenus).find((menu) => location.pathname.startsWith(menu));

  if (!currentMenu) return null;

  useEffect(() => {
    const items = subMenus[currentMenu];
    if ((location.pathname === currentMenu) && items && items.length > 0) {
      // Automatically navigate to the first submenu item
      history.replace(items[0].path);
    }
  }, [location.pathname, currentMenu, history]);

  return (
    <div className="sub-menu">
      {subMenus[currentMenu].map((item) => (
        <div
          key={item.path}
          className={`sub-menu-item ${
            location.pathname === item.path ? 'active' : ''
          }`}
          onClick={() => history.push(item.path)}
          role="button"
          tabIndex={0}
          onKeyPress={() => history.push(item.path)}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
};

export default withRouter(SubMenu);
